import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  // The feature being toggled and the direction of the change.
  featureLabel: string;
  enabling: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
};

// Confirmation step before a super admin flips a platform-wide feature flag.
const FeatureFlagConfirmModal = ({ isOpen, onClose, featureLabel, enabling, isLoading, onConfirm }: Props) => (
  <ModalContainer isOpen={isOpen} onClose={onClose} title={enabling ? 'Enable feature' : 'Disable feature'} overflowY="hidden">
    <VStack alignItems="center" gap="20px">
      <VStack gap="10px">
        <Text color="text.mediumBlue" fontSize="20px" textAlign="center">
          {enabling ? 'Turn on' : 'Turn off'} <Text as="span" fontWeight={800}>{featureLabel}</Text>?
        </Text>
        <Text variant="urbanistSemiBold" color="text.mediumBlue" fontSize="16px" textAlign="center">
          This {enabling ? 'enables' : 'disables'} the feature for all users across the platform, effective immediately.
        </Text>
      </VStack>

      <HStack gap="12px">
        <CustomButton label="Cancel" isTransparent labelColor="text.mediumBlue" labelHoverColor="extra.black" onClick={onClose} />
        <CustomButton
          label={enabling ? 'Enable' : 'Disable'}
          backgroundColor={enabling ? 'primary.500' : 'extra.red'}
          labelColor="extra.white"
          isLoading={isLoading}
          onClick={onConfirm}
        />
      </HStack>
    </VStack>
  </ModalContainer>
);

export default FeatureFlagConfirmModal;
